import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "util--screen-reader" }
const _hoisted_2 = { class: "content-grid" }

import {useI18n} from "vue3-i18n"
import {onMounted, ref} from "vue"
import {useInvoiceService} from "@/inversify.config"
import InvoiceTable from "@/components/tables/InvoiceTable.vue";
import {Invoice} from "@/types/entities";
import {ProductCategory} from "@/types/productCategory";
import {getValueForLocale} from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'Invoices',
  setup(__props) {

const {t} = useI18n()

const invoiceService = useInvoiceService()

const invoices = ref<Invoice[]>([])
const invoicesAreLoading = ref(false)

onMounted(async () => {
  await loadInvoices()
})

async function loadInvoices() {
  invoicesAreLoading.value = true

  let myInvoices = await invoiceService.getMyInvoices()
  if (myInvoices) {
    myInvoices.forEach(invoice => {
      let title = invoice.productCategory == ProductCategory.MembershipPlan
          ? invoice.createdAt
          : getValueForLocale(invoice.productName)
      invoice.description = `${t(`products.${invoice.productCategory}`)} : ${title}`
    })
    invoices.value = myInvoices
  }
  invoicesAreLoading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)("routes.invoices.name")), 1),
    _createElementVNode("div", _hoisted_2, [
      (invoices.value)
        ? (_openBlock(), _createBlock(InvoiceTable, {
            key: 0,
            invoices: invoices.value,
            "is-loading": invoicesAreLoading.value,
            title: _unref(t)('routes.invoices.name')
          }, null, 8, ["invoices", "is-loading", "title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})